import type { SlideDto, SlideSummaryDto, SlideVersionDto } from '@pb/shared';
import { asList, get, patch, post, query, uploadFile } from './client';

export interface SlideSearch {
  query?: string;
  tagIds?: number[];
  includeRetired?: boolean;
  untagged?: boolean;
  unused?: boolean;
  sort?: 'title' | 'last_change';
}

export const searchSlides = async (projectId: number, search: SlideSearch) =>
  asList(
    await get<SlideSummaryDto[] | { items: SlideSummaryDto[] }>(
      `/projects/${projectId}/slides${query({
        query: search.query?.trim(),
        tag_ids: search.tagIds,
        include_retired: search.includeRetired ? true : undefined,
        untagged: search.untagged ? true : undefined,
        unused: search.unused ? true : undefined,
        sort: search.sort,
      })}`,
    ),
  );
export const getSlide = (id: number) => get<SlideDto>(`/slides/${id}`);
export const updateSlide = (id: number, title: string) => patch<SlideDto>(`/slides/${id}`, { title });
export const listSlideVersions = async (id: number) =>
  asList(await get<SlideVersionDto[] | { items: SlideVersionDto[] }>(`/slides/${id}/versions`));
export const uploadSlideVersion = (
  id: number,
  file: File,
  note: string,
  eventId: number | null,
  onProgress: (fraction: number) => void,
) =>
  uploadFile<unknown>(
    `/slides/${id}/versions`,
    file,
    { note: note.trim() || undefined, event_id: eventId === null ? undefined : String(eventId) },
    onProgress,
  );
export const slideVersionFileUrl = (versionId: number) => `/api/slide-versions/${versionId}/file`;
export const retireSlide = (id: number, confirm: string) => post<SlideDto>(`/slides/${id}/retire`, { confirm });
export const unretireSlide = (id: number) => post<SlideDto>(`/slides/${id}/unretire`, {});
